import { QueryKeysConfig } from "@/config/query-keys";
import { createFileRoute } from "@tanstack/react-router";
import { useSearchPostsByTermLoader } from "@/hooks/network/use-search-posts-by-term-loader";
import PostsFeed from "@/components/PostsFeed";
export const Route = createFileRoute("/search/$term")({
  component: SearchByTerm,
  shouldReload() {
    return false;
  },
  async loader(ctx) {
    const load = () => Promise.resolve();
    await load();
  },
  head(ctx) {
    const title = `Поиск по запросу ${ctx.params.term}`;
    return {
      meta: [{
        title
      }, {
        name: "og:title",
        content: title
      }]
    };
  }
});
function SearchByTerm() {
  const {
    term
  } = Route.useParams();
  const searchPosts = useSearchPostsByTermLoader();
  const queryKey = [QueryKeysConfig.searchPostsByTerm, {
    term
  }];
  const loader = ({
    pageParam
  }: any) => {
    return searchPosts({
      data: {
        after: pageParam,
        term
      }
    });
  };
  return <PostsFeed queryKey={queryKey} loader={loader} />;
}